jQuery(document).ready(function ($) {
    "use strict";

    $(window).scroll(function () {
        if ($(window).scrollTop() > 545) {
            $('#scrolltop').addClass('is-visible');
        }
        else {
            $('#scrolltop').removeClass('is-visible');
        }
    });

});
